import React, { useEffect, useState } from "react"
import Button from "@modul-connect/shared/components/atoms/button"
import modal from "@modul-connect/shared/components/atoms/modal"
import { H1, P, Span } from "@modul-connect/shared/components/atoms/text"
import View from "@modul-connect/shared/components/atoms/view"
import { Checkbox, Fade, Modal } from "@mui/material"
import { ThemeProvider } from "@mui/material/styles"
import TextField from "@modul-connect/shared/components/molecules/textField"
import theme from "@modul-connect/shared/theme"
import { DateTime } from "luxon"

const contentGap = 12
const sectionStyle = { display: "flex", flexDirection: "column", gap: contentGap }
const labelStyle = { fontSize: 12, marginLeft: 3, color: theme.colors.darkGrey }

export const ModalCreateMessage = ({ openModal, onClose, onCreateMessage, saving }) => {

  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [startDate, setStartDate] = useState(
    DateTime.local().toFormat("yyyy-MM-dd'T'HH:mm")
  )
  const [endDate, setEndDate] = useState("")
  const [visibleForTechnician, setVisibleForTechnician] = useState(false)
  const [visibleForEndUser, setVisibleForEndUser] = useState(false)
  const [platformApp, setPlatformApp] = useState(false)
  const [platformPortal, setPlatformPortal] = useState(false)

  const showVisibleFor = platformApp

  const isFormValid =
    !!title?.trim() &&
    !!description?.trim() &&
    !!startDate &&
    (platformApp || platformPortal) &&
    (!platformApp || visibleForTechnician || visibleForEndUser)

  const isSubmitDisabled =
    !isFormValid || saving == null || saving?.createDisturbance === "saving"

  useEffect(() => {
  if (openModal) {
    setTitle('')
    setDescription('')
    setStartDate(DateTime.local().toFormat("yyyy-MM-dd'T'HH:mm"))
    setEndDate('')
    setVisibleForTechnician(false)
    setVisibleForEndUser(false)
    setPlatformApp(false)
    setPlatformPortal(false)
  }
}, [openModal])

  useEffect(() => {
    if (!platformApp) {
      setVisibleForTechnician(false)
      setVisibleForEndUser(false)
    }
  }, [platformApp])

 const onSave = () => {
    const visibleFor = []

    if (visibleForTechnician) visibleFor.push("technician")
    if (visibleForEndUser) visibleFor.push("endUser")

    const domain = []
    if (platformApp) domain.push("app")
    if (platformPortal) domain.push("portal")

   const data = {
      title,
      description,
      startingAt: DateTime.fromISO(startDate).toUTC().toISO(),
      endingAt: DateTime.fromISO(endDate).toUTC().toISO(),
      visibleFor, 
      domain
    }

    onCreateMessage(data)
 }

  return (
    <Modal
      open={openModal}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <ThemeProvider theme={theme.mui}>
        <Fade in={openModal}>
          <div>
            <View extend={{...modal.container, top: '12%', }}>
            <View extend={{...modal.header, flexDirection: 'column', alignItems: 'flex-start'}}>
              <H1 text="Add Disturbance Message" />
                {saving.createDisturbance === 'failed' && <P large style={{ color: theme.colors.error }}>Adding disturbance message failed. (Server error)</P>}
            </View>

            <View extend={modal.content} style={sectionStyle}>
              <P noPadding extend={{fontSize: 14}}>Only one disturbance message can be active at a time in the app and the portal.</P>
              <TextField name="Title" placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} />

              <TextField
                name="Description"
                label="Description"
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <View style={{ ...sectionStyle, gap: 0 }}>
                <Span extend={labelStyle}>Platform</Span>
                <View style={{ display: "flex", flexDirection: "row", gap: 12 }}>
                  <CheckboxItem
                    label="App"
                    checked={platformApp}
                    onChange={setPlatformApp}
                  />
                  <CheckboxItem
                    label="Portal"
                    checked={platformPortal}
                    onChange={setPlatformPortal}
                  />
                </View>
              </View>
              
              <View style={{ ...sectionStyle, gap: 0}}>
                <Span extend={labelStyle}>Visible for (App)</Span>
                <View style={{ display: "flex", flexDirection: "row", gap: 12}}>
                  <CheckboxItem
                    label="Technician"
                    checked={visibleForTechnician}
                    onChange={setVisibleForTechnician}
                    disabled={!showVisibleFor}
                  />
                  <CheckboxItem
                    label="End user"
                    checked={visibleForEndUser}
                    onChange={setVisibleForEndUser}
                    disabled={!showVisibleFor}
                  />
                </View>
              </View>
              
                
              <View style={sectionStyle}>
                <TextField
                  name="Start date & time"
                  type="datetime-local"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
                <TextField
                  name="End date & time"
                  type="datetime-local"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </View>
          
            </View>

            <View extend={modal.footer}>
              <Button noBg cancel onClick={() => onClose()}>
                Cancel
              </Button>
              <Button noBg disabled={isSubmitDisabled} noPadding onClick={onSave}>
                Submit
              </Button>
            </View>
          </View>
        </div>
        </Fade>
      </ThemeProvider>
    </Modal>
  )
}


const CheckboxItem = ({ label, checked, onChange, disabled }) => {
    return (
      <View
        extend={[
          {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            height: "30px",
            "&:hover": {
              cursor: disabled ? "default" : "pointer",
            },
            opacity: disabled ? 0.3 : 1
          },
        ]}
            onClick={() => {
              if (disabled) return
              onChange(!checked)
            }}
          >
        <View style={{}}>
          <Checkbox
            disabled={disabled}
            size="small"
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
            style={{ color: "green" }}
          />
        </View>
        <View style={{}}>
          <P>{label}</P>
        </View>
      </View>
    );
  };